import { useEffect, useState } from 'react'

/** The current time, re-rendered every `intervalMs` (default 30s) so clock-derived UI — countdowns,
 *  "happening now" / phase flips — stays honest on its own. */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
